export default __webpack_public_path__ + "static/media/qr-code.1ca204e9.png";